import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import LoginPage from './LoginPage';
import Dashboard from './Dashboard';
import PatientReportPage from './PatientReportPage';

// Auth check function
const isAuthenticated = () => {
  return !!Cookies.get('access_token');
};

// Protected route component that checks for authentication
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" />;
  }
  
  return children;
};

// Route that redirects authenticated users away from login
const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    // Redirect to dashboard if already logged in
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes - redirects to dashboard if already logged in */}
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } 
        />
        
        {/* Protected routes - requires authentication */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        <Route
          path="/patients/:userId/report"
          element={
            <ProtectedRoute>
              <PatientReportPage />
            </ProtectedRoute>
          }
        />
        
        {/* Default route - redirect to dashboard if logged in, otherwise to login */}
        <Route 
          path="*" 
          element={
            isAuthenticated() ? 
              <Navigate to="/dashboard" /> : 
              <Navigate to="/login" />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
